import React, { useEffect, useCallback, useSyncExternalStore } from 'react';
import { useDispatch } from 'react-redux';
import notification from 'antd/es/notification';
import { useTranslation } from 'react-i18next';

import { getOpParams } from 'utils/getOpParams';
import { useGetActiveScopes } from 'utils/customHooks/useGetActiveScopes';
import { verifyScope } from 'utils/redirects';
import alarmEditRouteConfig from 'routes/AlarmDashboardPage/AlarmEditPage/route';
import { useOpNotificationOptional } from 'new-components/OpAppScaffold/components/OpNotificationProvider';

import { notificationService } from './notificationService';
import { buildNotificationActions } from './buildNotificationActions';
import { ClearAllAlertsButton } from './components/ClearAllAlertsButton';

import './AlertWrapper.scss';

export const AlertWrapper = React.memo(() => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const apiFromContext = useOpNotificationOptional();
  const [ownApi, contextHolder] = notification.useNotification();

  const api = apiFromContext ?? ownApi;

  const { orgId } = getOpParams();
  const { activeScopes } = useGetActiveScopes(orgId);
  const canEditAlarms = verifyScope(
    activeScopes,
    alarmEditRouteConfig.scope,
    orgId,
  );

  const openCount = useSyncExternalStore(
    notificationService.subscribe,
    notificationService.getOpenCount,
  );

  useEffect(() => {
    notificationService.setApi(api);
    notificationService.setActionRenderer((alert, close) =>
      buildNotificationActions(alert, close, {
        dispatch,
        t,
        canEditAlarms,
      }),
    );
    return () => {
      notificationService.setApi(null);
      notificationService.setActionRenderer(null);
    };
  }, [api, dispatch, t, canEditAlarms]);

  const handleCloseAll = useCallback(() => {
    notificationService.clearAll();
  }, []);

  return (
    <>
      {!apiFromContext && contextHolder}
      {openCount > 3 && <ClearAllAlertsButton onClick={handleCloseAll} />}
    </>
  );
});
